import { handleActions } from 'redux-actions';

import { LOGIN, LOGOUT } from '../constants/Constants';
import { loadAuth } from '../utils/Utils';

const initialState = loadAuth();

export default handleActions(
  {
    [LOGIN.PENDING]: () => ({ pending: true }),
    [LOGIN.SUCCESS]: (state, { payload }) => payload,
    [LOGIN.ERROR]: (state, { payload }) => ({ error: true }),
    [LOGOUT.SUCCESS]: () => ({})
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/AuthReducer.js